// extracted by mini-css-extract-plugin
export default {"tr":"mappropertytable_tr__viYum","headertitle":"mappropertytable_headertitle__VlD5m"};